// extracted by mini-css-extract-plugin
export default {"containerWrapper":"CardSellersContainer_containerWrapper__4dSNX","slider":"CardSellersContainer_slider__dGTk2","cardWrapper":"CardSellersContainer_cardWrapper__L9qbP"};